var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "curr-month-overview" },
    [
      _c("div", { staticClass: "record-title" }, [
        _vm._v("教师登录及处理情况"),
      ]),
      _c(
        "div",
        { staticClass: "title-1", staticStyle: { margin: "20px 0 15px" } },
        [_vm._v("整体使用情况")]
      ),
      _c("OverallUsage", { attrs: { dataSource: _vm.overallUsageInfo } }),
      _c(
        "div",
        { staticClass: "title-1", staticStyle: { margin: "20px 0 15px" } },
        [_vm._v("优秀标杆班主任")]
      ),
      _c(
        "div",
        { staticClass: "excellent-header-tea flex-between" },
        [
          _c("HandleInTime", {
            staticClass: "header-tea-item",
            staticStyle: { "background-color": "#eefcf4" },
            attrs: {
              title: "处理及时班主任",
              dataSource: _vm.handleInTimeData,
            },
          }),
          _c("RecordCarefully", {
            staticClass: "header-tea-item",
            attrs: {
              title: "记录认真班主任",
              dataSource: _vm.recordCarefullyData,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c("ActionRecordTable", {
            ref: "actionRecordRef1",
            attrs: {
              title: "班主任登录及使用情况",
              url: _vm.url1,
              columns: _vm.columns1,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c("ActionRecordTable", {
            ref: "actionRecordRef2",
            attrs: {
              title: "处理率较低班级",
              url: _vm.url2,
              columns: _vm.columns2,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }